import { all, takeEvery, put, call, select } from "redux-saga/effects";
import actions from "./actions";
import * as services from "./services";

const getUserState = (state) => state.users;

export function* GET_USER({payload}) {
  debugger;
  yield put({
    type: actions.SET_STATE,
    payload:{loading: true}
  })
  const {uid} = payload
  const response = yield call(services.getUser, uid);
  const creditzIds = yield call(services.getCreditzLength, uid);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        user: { ...response },
        creditzIds: creditzIds,
        authenticated: true,
        loading: false,
      },
    });
    yield put({
      type: actions.GET_USER_MUSICS,
      payload: {creditzIds}
    })
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        user: {},
        authenticated: false,
        globalLoading: false,
      },
    });
  }
}

export function* GET_USER_MUSICS({payload}) {
  const {creditzIds = []} = payload
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  });
  const creditz = [];
  if (creditzIds.length === 0) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    });
    return;
  }
  for (let i = 0; i < creditzIds.length; i++) {
    const response = yield call(services.getUserMusics, creditzIds[i]);
    creditz.push(response);
  }
  if (creditz) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        creditz,
        loading: false,
      },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    });
  }
}

export function* GET_ALL_ACHIEVEMENTS() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  });
  const { user } = yield select(getUserState);
  const response = yield call(services.getAllAchievements, user.uid);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        achievements: response,
        loading: false,
      },
    });
  } else {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
      },
    });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.GET_USER, GET_USER),
    takeEvery(actions.GET_USER_MUSICS, GET_USER_MUSICS),
    takeEvery(actions.GET_ALL_ACHIEVEMENTS, GET_ALL_ACHIEVEMENTS),
  ]);
}
